import { render, staticRenderFns } from "./ServRelacion.vue?vue&type=template&id=09908460&"
import script from "./ServRelacion.vue?vue&type=script&lang=js&"
export * from "./ServRelacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports